import { useEffect, useState } from 'react';

/**
 * Returns { isActive } representing if the html element contains the "un-assistive" class.
 * This will be used to change the text of the banner.
 */
export const useUsableNetActive = () => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const root = document.documentElement;

    const observer = new MutationObserver(() => {
      setIsActive(root.classList.contains('un-assistive'));
    });

    observer.observe(root, {
      attributes: true,
      attributeFilter: ['class'],
    });

    setIsActive(root.classList.contains('un-assistive'));

    return () => {
      observer.disconnect();
    };
  }, []);

  return { isActive };
};
